import React, { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import Loader from '../../common/Loader';
import alertExclamationIcon from '../../../../assets/icons/alert-icon.svg';
import closeDialogIcon from '../../../../assets/icons/close-dialog-icon.svg';
import styles from './UnlinkDeviceDialog.scss';

interface ConfirmModalProps {
  isOpen: boolean;
  title: ReactNode;
  onConfirm: () => void;
  onClose: () => void;
  confirmButtonText?: string;
  isLoading?: boolean;
  error?: string;
}

const ConfirmModal = ({
  isOpen,
  isLoading,
  title,
  confirmButtonText = 'Confirm',
  onConfirm,
  onClose,
  error,
}: ConfirmModalProps) => (
  <div className={styles.overlay} hidden={!isOpen}>
    <div className={`${styles.dialog} ${error ? styles.dialogWithError : ''}`}>
      <button className={styles.closeDialogButton} onClick={onClose}>
        <img src={closeDialogIcon} width="14" height="14" alt="" />
      </button>

      <img src={alertExclamationIcon} className={styles.alertIcon} width="48" height="48" alt="" />

      <h3 className={styles.title}>{title}</h3>

      <div className={styles.buttonsLine}>
        <button className={styles.goBackButton} onClick={onClose}>
          <FormattedMessage id="confirmModal.cancelButton" defaultMessage="Cancel" />
        </button>

        <button className={styles.cancelButton} onClick={onConfirm}>
          {isLoading ? <Loader size={20} /> : confirmButtonText}
        </button>
      </div>

      {error ? <span className={styles.error}>{error}</span> : null}
    </div>
  </div>
);

export default ConfirmModal;
